
import { defineComponent, computed } from '@nuxtjs/composition-api';

const colors = {
  white: {
    text: 'text-white',
    shadow: 'shadow-[0_0_5px_1px_rgba(255,255,255,0.5)]',
    icon: 'bg-white',
  },
  red: {
    text: 'text-gradient',
    shadow: 'shadow-[0_0_5px_1px_rgba(182,71,255,0.8)]',
    icon: 'bg-pink',
  },
};

export default defineComponent({
  name: 'ProductFeatureGroupItem',
  props: {
    name: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: 'white',
    },
  },

  setup(props) {
    const colorClasses = computed(() => colors[props.color]);

    return { colorClasses };
  },
});
